module.exports = __webpack_public_path__ + "static/fonts/OpenSans800.11d37998.ttf";